module.exports = __webpack_public_path__ + "assets/svg/Icons/32/shift-leave-gray-727ca0.svg";